import { render, staticRenderFns } from "./BugreportDialog.vue?vue&type=template&id=95ad0f42&"
import script from "./BugreportDialog.vue?vue&type=script&lang=js&"
export * from "./BugreportDialog.vue?vue&type=script&lang=js&"
import style0 from "./BugreportDialog.vue?vue&type=style&index=0&id=95ad0f42&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports